import React, { useState } from "react";
import { Quote, ChevronLeft, ChevronRight } from "lucide-react";
import { testimonials } from "../data/mock";

const Testimonials = () => {
  const [idx, setIdx] = useState(0);
  const t = testimonials[idx];

  const prev = () => setIdx((i) => (i - 1 + testimonials.length) % testimonials.length);
  const next = () => setIdx((i) => (i + 1) % testimonials.length);

  return (
    <section className="section bg-[#F8F5EE]">
      <div className="max-w-5xl mx-auto container-px text-center reveal">
        <Quote size={36} className="mx-auto text-[#C9A961]" />
        <p className="font-serif text-2xl lg:text-4xl leading-[1.35] text-[#0B1E3F] mt-8 px-2">
          “{t.quote}”
        </p>
        <div className="mt-10">
          <div className="text-[13px] tracking-[0.2em] uppercase text-[#C9A961]">{t.name}</div>
          <div className="text-[13px] text-[#0B1E3F]/60 mt-1">{t.role}</div>
        </div>

        <div className="mt-10 flex items-center justify-center gap-3">
          <button
            onClick={prev}
            aria-label="Previous testimonial"
            className="w-11 h-11 border border-[#0B1E3F]/20 flex items-center justify-center text-[#0B1E3F] hover:bg-[#0B1E3F] hover:text-[#F8F5EE] transition-colors duration-300"
          >
            <ChevronLeft size={18} />
          </button>
          <div className="flex gap-1.5">
            {testimonials.map((_, i) => (
              <button
                key={i}
                onClick={() => setIdx(i)}
                aria-label={`Go to testimonial ${i + 1}`}
                className={`h-1 transition-all duration-300 ${
                  i === idx ? "w-8 bg-[#C9A961]" : "w-3 bg-[#0B1E3F]/20"
                }`}
              />
            ))}
          </div>
          <button
            onClick={next}
            aria-label="Next testimonial"
            className="w-11 h-11 border border-[#0B1E3F]/20 flex items-center justify-center text-[#0B1E3F] hover:bg-[#0B1E3F] hover:text-[#F8F5EE] transition-colors duration-300"
          >
            <ChevronRight size={18} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
